'use client'

import { EventBoardListType, iconUrl } from "@/type/list";
import api from "@/util/api";
import moment from "moment"
import 'moment/locale/ko';
import { useContext, useEffect, useState } from "react"
import SectionTitle from "../../components/etc/section_title";
import ImageList from "../../components/board/image_list";
import { NavContext } from "@/context/navContext";
import { useTranslations } from "next-intl";

export default function EventListSide() {
    const { movePage } = useContext(NavContext)
    const [list, setList] = useState<EventBoardListType[]>([])
    
    const t = useTranslations('PageTitle')
    
    function setContent(content_id: number) {
        movePage(`/event/?id=${content_id}`)
    }

    function fetchData() {
        const apiUrl = `/api/event/board/?page_count=4`
        api(apiUrl)
            .then(res => res.json())
            .then(({ data }) => {

                const getData: any[] = data.posts
                setList(getData)
            })
    }

    useEffect(() => {
        fetchData()
    }, [])

    return (
        <div className="">
            <SectionTitle shortCut={`/event/`} >{t('BIG 이벤트')}</SectionTitle>
            <ImageList list={list} setContent={setContent} />
        </div>
    )
}